export type DashToCamelCase<S extends string> = S extends `${infer Head}-${infer Tail}`
  ? `${Head}${Capitalize<DashToCamelCase<Tail>>}`
  : S;

export function dashCaseToCamelCase<S extends string>(str: S): DashToCamelCase<S> {
  return str.replace(/-([a-z0-9])/g, (_, letter) => letter.toUpperCase()) as DashToCamelCase<S>;
}
